import Card from "@mui/material/Card";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Table from "examples/Tables/Table";

import SuiAlert from "components/SoftAlert";

// import the hook instead of static data
import useAuthorsTableData from "layouts/receipts/data/storesTableData";
import usePendingReceiptTableData from "layouts/receipts/data/pendingReceiptTableData"
import { WarningRounded } from "@mui/icons-material";
import { Chip } from "@mui/material";

function Tables() {
  // call the hook here
  const { columns, rows, loading, storeCount, maxStores, viewReceiptDialog } = useAuthorsTableData();
  const { columns2, rows2, loading2, receiptCount, storeAddress, viewReceiptDialog2 } = usePendingReceiptTableData();

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox py={3}>
        <SoftBox mb={3}>
          <Card>
            <SoftBox display="flex" justifyContent="space-between" alignItems="center" p={3}>
              <SoftTypography variant="h6">Displaying pending receipts for {storeAddress} {receiptCount > 0 ? <Chip label={receiptCount} /> : null}</SoftTypography>
            </SoftBox>
            <SoftBox
              sx={{
                "& .MuiTableRow-root:not(:last-child)": {
                  "& td": {
                    borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                      `${borderWidth[1]} solid ${borderColor}`,
                  },
                },
              }}
            >
              {loading ? (
                <SoftTypography p={3} variant="body2">
                  Loading team...
                </SoftTypography>
              ) : (
                <Table columns={columns2} rows={rows2} />
              )}
            </SoftBox>
          </Card>
        </SoftBox>

        <SoftBox mb={3}>
          <Card>
            <SoftBox display="flex" justifyContent="space-between" alignItems="center" p={3}>
              <SoftTypography variant="h6">Displaying recent receipts</SoftTypography>
            </SoftBox>
            <SoftBox
              sx={{
                "& .MuiTableRow-root:not(:last-child)": {
                  "& td": {
                    borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                      `${borderWidth[1]} solid ${borderColor}`,
                  },
                },
              }}
            >
              {loading ? (
                <SoftTypography p={3} variant="body2">
                  Loading team...
                </SoftTypography>
              ) : (
                <Table columns={columns} rows={rows} />
              )}
            </SoftBox>
          </Card>
        </SoftBox>
      </SoftBox>
      {viewReceiptDialog}
      {viewReceiptDialog2}
      <Footer />
    </DashboardLayout>
  );
}

export default Tables;
